module.exports = __webpack_public_path__ + "img/huaxia03.b26d419d.png";